(function () {
  function initSaleBars(scope) {
    (scope || document).querySelectorAll('.tg .sale[data-tg-sale-config]').forEach(function (bar) {
      if (bar.dataset.tgSaleReady === '1') return;
      bar.dataset.tgSaleReady = '1';

      var showCountdown = bar.getAttribute('data-sale-show-countdown') !== 'false';
      var duration = parseInt(bar.getAttribute('data-sale-duration'), 10);
      if (!Number.isFinite(duration) || duration < 0) duration = (2 * 3600) + (18 * 60) + 45;

      var daysNode = bar.querySelector('[data-tg-sale-time="days"]');
      var hoursNode = bar.querySelector('[data-tg-sale-time="hours"]');
      var minutesNode = bar.querySelector('[data-tg-sale-time="minutes"]');
      var secondsNode = bar.querySelector('[data-tg-sale-time="seconds"]');
      var countdown = bar.querySelector('.tg-countdown');
      if (!showCountdown && countdown) countdown.hidden = true;
      if (!showCountdown || !hoursNode || !minutesNode || !secondsNode) return;

      var endAt = Date.now() + duration * 1000;
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var left = Math.max(0, Math.floor((endAt - Date.now()) / 1000));
        var values = daysNode ? [Math.floor(left / 86400), Math.floor((left % 86400) / 3600), Math.floor((left % 3600) / 60), left % 60] : [Math.floor(left / 3600), Math.floor((left % 3600) / 60), left % 60];
        (daysNode ? [daysNode, hoursNode, minutesNode, secondsNode] : [hoursNode, minutesNode, secondsNode]).forEach(function (node, idx) {
          node.textContent = pad(values[idx]);
        });
        if (left <= 0 && bar._tgSaleInterval) {
          window.clearInterval(bar._tgSaleInterval);
          bar._tgSaleInterval = null;
        }
      }
      tick();
      bar._tgSaleInterval = window.setInterval(tick, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSaleBars(document); }, { once: true });
  } else {
    initSaleBars(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initSaleBars(event.target); });
})();